var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.HtmlRenderer,{staticClass:"ab-description",class:[
    {
      'ab-description_center': _vm.center || _vm.align === 'center',
      'ab-description_left': _vm.align === 'left',
      'ab-description_right': _vm.align === 'right',
    },
  ],attrs:{"tag":"p","content":_vm.content}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }